export const GET_DEFAULT_ZEBRA_PRINTERS_REQUEST = 'GET_DEFAULT_ZEBRA_PRINTERS_REQUEST'
export const GET_DEFAULT_ZEBRA_PRINTERS_SUCCESS = 'GET_DEFAULT_ZEBRA_PRINTERS_SUCCESS'
export const GET_DEFAULT_ZEBRA_PRINTERS_FAILURE = 'GET_DEFAULT_ZEBRA_PRINTERS_FAILURE'

export const PRINT_ZEBRA_LABEL_REQUEST = 'PRINT_ZEBRA_LABEL_REQUEST'
export const PRINT_ZEBRA_LABEL_SUCCESS = 'PRINT_ZEBRA_LABEL_SUCCESS'
export const PRINT_ZEBRA_LABEL_FAILURE = 'PRINT_ZEBRA_LABEL_FAILURE'
